import zhCN from './json/push-card.zh_CN.json';
import zhTW from './json/push-card.zh_TW.json';
import en from './json/push-card.en.json';
import ja from './json/push-card.ja.json';
import ko from './json/push-card.ko.json';
import ru from './json/push-card.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
